module.exports = __webpack_public_path__ + "img/ailogo.b8a72189.png";